import { graphql } from 'react-relay';
import { genericMutation } from '../utils';
import type { ZnglyVideo_DeleteZnglyVideo_Mutation } from './__generated__/ZnglyVideo_DeleteZnglyVideo_Mutation.graphql';

export * from './__generated__/ZnglyVideo_DeleteZnglyVideo_Mutation.graphql';
export const DeleteZnglyVideoMutation = graphql`
  mutation ZnglyVideo_DeleteZnglyVideo_Mutation($input: DeleteZnglyVideoExtraInput!) {
    deleteZnglyVideoExtra(input: $input) {
      deletedId @deleteRecord
    }
  }
`;

export const deleteZnglyVideoMutation = genericMutation<ZnglyVideo_DeleteZnglyVideo_Mutation>({
  mutation: DeleteZnglyVideoMutation,
});
